import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { techdocsPlugin } from '@backstage/plugin-techdocs';
import {
  RecentPageHeader,
  RelatedLinksCard,
} from '@internal/plugin-neo4j-techdocs';

export const techdocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [
    // ── Routes (→ app/routes) ───────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/docs',
        noHeader: true,
        routeRef: techdocsPlugin.routes.root,
        loader: () =>
          import('@internal/plugin-neo4j-techdocs').then(m => (
            <m.DocsIndexPage />
          )),
      },
    }),
    PageBlueprint.make({
      name: 'reader',
      params: {
        path: '/docs/:namespace/:kind/:name',
        noHeader: true,
        routeRef: techdocsPlugin.routes.docRoot,
        loader: () =>
          import('@internal/plugin-neo4j-techdocs').then(({ ReaderPage }) => (
            <ReaderPage />
          )),
      },
    }),

    // ── TechDocs addons (→ reader slots) ────────────────────
    // Only the upstream entity Docs tab reads these. The /docs reader page
    // above lists its addons itself, in the plugin ReaderPage.
    AddonBlueprint.make({
      name: 'related-links',
      params: {
        name: 'RelatedLinks',
        location: 'SecondarySidebar',
        component: RelatedLinksCard,
      },
    }),
    AddonBlueprint.make({
      name: 'recent-page-header',
      params: {
        name: 'RecentPageHeader',
        location: 'Subheader',
        component: RecentPageHeader,
      },
    }),
  ],
});
